import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { kakaoCertiStatus } from '@store/actions/userAction';

const LoginKakaoCertificateComplete = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const onButtonClickHandler = () => {
        dispatch(kakaoCertiStatus());
    }
    return (
        <>
            <div className='page-navi'>
                <button type='button' className='btn-back' onClick={() => history.goBack()}><span className='hide'>이전</span></button>
            </div>
            <h3 className='tit-con'>카카오페이 인증서</h3>
            <p className='text-con'>
                카카오페이에서 인증 완료 후 사용이 가능합니다.
            </p>
            
            <div className='logincon-area'>							
                <div className="info-box-ctfStep">
                    <ul className="ctfStep-list">
                        <li>
                            <div className="ctfStep-tit ctfStep-01 ctfStep-ka"><span>step 1</span></div>
                            <div className="ctfStep-con">
                                앱에서 인증요청<br/>메세지 확인
                            </div>
                        </li>									
                        <li>
                            <div className="ctfStep-tit ctfStep-02"><span>step 2</span></div>
                            <div className="ctfStep-con">
                                인증진행<br/>(비밀번호 등)
                            </div>
                        </li>
                        <li>
                            <div className="ctfStep-tit ctfStep-03"><span>step 3</span></div>
                            <div className="ctfStep-con">
                                인증완료 후,<br/>하단의 인증완료 클릭
                            </div>
                        </li>
                    </ul>
                </div>
            </div>	
            
            <div className='btn-area'>
                <button type='button' className='btn-l blue' onClick={onButtonClickHandler}>인증완료</button>
            </div>
        </>
    );
}

export default LoginKakaoCertificateComplete;